import { appConfig } from '../../core/config/appConfig';

export const firebaseConfig = appConfig.firebase.apiKey ? appConfig.firebase : {
    apiKey: "AIzaSyBTrpKnfQG2-RFWfOlxEEs-7AOsSi8F4rY",
    authDomain: "teamdaksha369.firebaseapp.com",
    databaseURL: "https://teamdaksha369-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "teamdaksha369",
    storageBucket: "teamdaksha369.firebasestorage.app",
    messagingSenderId: "451725604470",
    appId: "1:451725604470:web:0ed8d73b617b27f1109157",
    measurementId: "G-N0CFMGC1CQ"
};
